import _asyncToGenerator from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import _regeneratorRuntime from "/home/runner/work/125-guest-ui/125-guest-ui/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.string.link.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { get } from 'vuex-pathify';
import openURL from 'quasar/src/utils/open-url.js';;
import { surveyCompleted, surveyShared } from "../../boot/google-analytics";
import { mdRender } from "../../functions/remarkable";
export default {
  name: 'Share',
  data: function data() {
    return {
      trackedShares: []
    };
  },
  computed: {
    branchDetails: get('config/getBranchDetails'),
    submitted: get('responses/submitted'),
    isApp: get('config/isApp'),
    survey: get('questions/getSurvey'),
    companyDetails: get('config/getCompanyDetails'),
    currentSurvey: get('surveys/currentSurvey'),
    shareEnabled: function shareEnabled() {
      return this.submitted && this.$store.getters['answers/sharingPermitted'] && this.sharingItems.length;
    },
    branchSocialUrls: function branchSocialUrls() {
      var _find,
          _this = this;

      // generate all the possible social links that are configured for the branch
      return {
        google: this.branchDetails.googleLink,
        facebook: this.branchDetails.facebookLink,
        twitter: this.branchDetails.twitterLink,
        tripadvisor: (_find = (this.branchDetails.tripadvisorLinks || []).find(function (tl) {
          return tl.surveyTypeId === _this.survey.surveyTypeId;
        })) === null || _find === void 0 ? void 0 : _find.link
      };
    },
    sharingItems: function sharingItems() {
      var _this2 = this;

      // todo support adding a new one from the recommend page later
      return (this.survey.sharingItems || []).map(function (_ref) {
        var buttonText = _ref.buttonText,
            icon = _ref.icon,
            overrideUrl = _ref.overrideUrl,
            socialType = _ref.socialType,
            sortOrder = _ref.sortOrder;

        // Handle default icons.
        if (icon === 'default') {
          icon = socialType === 'additional' ? 'select' : socialType;
        } // determine the social url of the sharing item based on the branch configuration


        var socialUrl = _this2.branchSocialUrls[socialType];
        return {
          type: socialType,
          label: buttonText,
          icon: "statics/icons/social/".concat(icon, ".svg"),
          iconProps: {
            width: '24px',
            height: '24px'
          },
          url: socialUrl || overrideUrl || _this2.buildShareLink(socialType),
          order: parseInt(sortOrder)
        };
      }) // We remove any share types which don't have urls - as they just wouldn't do anything!
      .filter(function (s) {
        return s.url;
      }).sort(function (a, b) {
        return a - b;
      });
    },
    tip: function tip() {
      var _this$branchDetails;

      var tip = (_this$branchDetails = this.branchDetails) === null || _this$branchDetails === void 0 ? void 0 : _this$branchDetails.tips;

      if (!tip || !tip.url) {
        return false;
      }

      var icon = 'money';

      if (tip.icon && tip.icon !== 'default') {
        icon = tip.icon;
      }

      var iconProps = icon === 'tipjar' ? {
        width: '50px',
        height: '21px'
      } : {
        width: '24px',
        height: '24px'
      };
      return {
        type: 'tip',
        label: tip.text || this.$tc('checkout.share.tip.label'),
        icon: "statics/icons/social/".concat(icon, ".svg"),
        iconProps: iconProps,
        url: tip.url
      };
    },
    tipEnabled: function tipEnabled() {
      var _this$branchDetails2, _this$branchDetails2$;

      return ((_this$branchDetails2 = this.branchDetails) === null || _this$branchDetails2 === void 0 ? void 0 : (_this$branchDetails2$ = _this$branchDetails2.tips) === null || _this$branchDetails2$ === void 0 ? void 0 : _this$branchDetails2$.enabled) || false;
    },
    webView: function webView() {
      // The Full Clarity app opens this app in a Cordova In App Browser (app). After using Chrome
      // Inspect on the app, you can see that window.cordova_iab is truthy.
      return !!window.cordova_iab;
    },
    branchId: function branchId() {
      return this.$store.state.config.branchId;
    },
    branchPasscode: function branchPasscode() {
      var _this3 = this;

      // Get the branch that passcode relates to first
      var branches = this.$store.state.checkIn.branches || [];
      var branch = branches.find(function (branch) {
        return branch.id === _this3.branchId;
      }) || {};
      return branch.hashCode;
    },
    surveyName: function surveyName() {
      return this.$store.state.checkIn.fetchedSlug;
    }
  },
  mounted: function mounted() {
    var _this$$store$getters$;

    var name = this.companyDetails.name;
    var _this$currentSurvey = this.currentSurvey,
        surveyId = _this$currentSurvey.surveyId,
        surveyTypeId = _this$currentSurvey.surveyTypeId;
    var branchId = this.branchDetails.id;
    surveyCompleted({
      companyName: name,
      surveyId: surveyId,
      surveyTypeId: surveyTypeId,
      branchId: branchId,
      isPveUser: !!((_this$$store$getters$ = this.$store.getters['checkIn/urlParams']) !== null && _this$$store$getters$ !== void 0 && _this$$store$getters$.pve)
    });
  },
  methods: {
    onShare: function onShare(item) {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this4$$store$getters, name, _this4$currentSurvey, surveyId, surveyTypeId, branchId;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // If they've already clicked for this type, don't track again, to avoid extraneous api calls
                if (!_this4.trackedShares.includes(item.type)) {
                  // Track the guest sharing their survey on other platforms - this is currently only
                  // available on certain platforms where there's backend support.
                  if (['facebook', 'twitter'].includes(item.type)) {
                    _this4.$store.dispatch('responses/track', [{
                      type: "shared_".concat(item.type)
                    }]);
                  }

                  _this4.trackedShares.push(item.type); // gtm execute survey surveyShared


                  name = _this4.companyDetails.name;
                  _this4$currentSurvey = _this4.currentSurvey, surveyId = _this4$currentSurvey.surveyId, surveyTypeId = _this4$currentSurvey.surveyTypeId;
                  branchId = _this4.branchDetails.id;
                  surveyShared({
                    companyName: name,
                    surveyId: surveyId,
                    surveyTypeId: surveyTypeId,
                    shareType: item.type,
                    branchId: branchId,
                    isPveUser: !!((_this4$$store$getters = _this4.$store.getters['checkIn/urlParams']) !== null && _this4$$store$getters !== void 0 && _this4$$store$getters.pve)
                  });
                }

                openURL(item.url);

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    buildShareLink: function buildShareLink(type) {
      var _this$submitted;

      var url = (_this$submitted = this.submitted) === null || _this$submitted === void 0 ? void 0 : _this$submitted.url;
      var encodedUrl = encodeURIComponent(url);
      var unencodedMessage = this.$tc('checkout.shareSocialMsg', this.branchDetails.name);

      switch (type) {
        case 'tripadvisor':
          // todo requires https://feeditback.atlassian.net/browse/FIB-8578
          return '';

        case 'facebook':
          return "http://www.facebook.com/sharer/sharer.php?u=".concat(encodedUrl);

        case 'twitter':
          {
            // If the branch has a twitter username, we can make a better share message than the
            // general one
            var encodedTwitterMessage = encodeURIComponent(this.branchDetails.twitterUsername ? this.$tc('checkout.shareSocialMsg', '@' + this.branchDetails.twitterUsername) : unencodedMessage);
            return "https://twitter.com/share?url=".concat(encodedUrl, "&text=").concat(encodedTwitterMessage);
          }
      } // We don't handle any other types


      return null;
    },
    onDone: function onDone() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var standalone;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                standalone = navigator.standalone || window.matchMedia('(display-mode: standalone)').matches; // This supports the Legacy Cordova wrapper app which is being phased out in favour of the
                // official FIB app = the PWA version of this codebase.

                if (!(_this5.webView && !standalone)) {
                  _context2.next = 4;
                  break;
                }

                _this5.$router.push("/".concat(_this5.surveyName, "/?branchId=").concat(_this5.branchId, "&inBranch=").concat(_this5.branchPasscode, "&isCordova=true"));

                return _context2.abrupt("return");

              case 4:
                if (!_this5.$store.getters['errors/error']) {
                  _this5.$router.push('/thank-you');
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderText: function renderText(text) {
      return mdRender(text);
    }
  }
};